export default __webpack_public_path__ + "static/media/interior (16).511f24ee.jpg";